export * from './default-setup.view';